const DefaultTransformer = <T>(data: T) => ({ data: { ...data } });

export default DefaultTransformer;
